import { toast } from 'react-toastify';
import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';

import { removeTokensFromLocalStorage } from '../../Functions/LocalStorageUtils';

// eslint-disable-next-line
const getErrorMessage = (action: any) => {
  if (action.payload?.data?.message) {
    return action.payload.data.message;
  }
  if (action.response?.data?.message) {
    return action.response.data.message;
  }
  if (action.payload?.data?.app_exception) {
    return action.payload.data.app_exception;
  }
  return action.message;
};

/**
 * Show a toast! with waring message
 */
// api ass the MiddlewareAPI object, which has access to the store - can be passed to as argument to first function
export const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
  // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
  if (isRejectedWithValue(action)) {
    if (action.meta.baseQueryMeta?.request?.method !== 'GET') {
      if (action.payload.status >= 400) {
        console.error(action.payload);
        toast.error(`${getErrorMessage(action)}`);
      }
    }
    if (action.payload.status === 401 && action?.meta?.arg?.endpointName !== 'userLogin') {
      // Error 401 - Unauthorized
      removeTokensFromLocalStorage();
    }
  }
  return next(action);
};
